export interface Edges<T> {
  edges: Array<{
    node: T;
  }>;
}

export const getNodes = <T>(obj?: Edges<T>): Array<T> =>
  (obj && obj.edges.map(e => e.node)) || [];
